import { breakpoints, Text, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const DrawerContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0 1rem;
  margin-bottom: 1.25rem;

  overflow-y: auto;

  @media (min-width: ${breakpoints.md}) {
    max-height: 300px;
    margin-bottom: 0.5rem;
  }
`;

export const contentStyles = css`
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;

  [data-testid='drawer-scrollable-content'] {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
`;

export const Title = styled(Text)`
  text-align: left;

  @media (min-width: ${breakpoints.md}) {
    text-align: center;
    font-size: 2rem;
    line-height: 2.2rem;
  }
`;

export const BenefitsList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const BenefitContent = styled.div<{ $isLast?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 0;
  border-bottom: ${({ $isLast }) =>
    $isLast ? 'none' : `1px solid ${theme.color.border.disabled}`};
`;

export const BenefitTitle = styled(Text)`
  font-weight: 500;
`;

export const BenefitDescription = styled(Text)`
  color: ${theme.color.text.secondary};
`;
